import React from "react";

import { useAuthState } from "src/features/auth/hooks/useAuthState";
import { useAutoSignOut } from "src/features/auth/hooks/useAutoSignOut";
import { useInitialize } from "src/features/auth/hooks/useInitialize";

export const Authenticated: React.FunctionComponent<
	React.PropsWithChildren
> = ({ children }) => {
	const { isAuthenticated } = useAuthState();
	useInitialize();
	useAutoSignOut();
	return isAuthenticated ? children : null;
};
